import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { AuthorShowPageProps } from "./show.props";
import { Letterbooks } from "features/Letterbooks";
import DynamicListContainer from "features/tags/components/TagHeader/DynamicListContainer/DynamicListContainer";
import Container from "hardcover-ui/components/Container";
import AuthorHeader from "components/authors/AuthorHeader";
import AuthorTabs from "components/authors/AuthorTabs";

function AuthorShowPage() {
  const { letterbooks, author, view } = usePage<AuthorShowPageProps>().props;

  return (
    <>
      <Container variant="layout" className="mb-4">
        <AuthorHeader author={author} />
        <AuthorTabs author={author} />
      </Container>

      <DynamicListContainer view={view}>
        <Letterbooks context={letterbooks} />
      </DynamicListContainer>
    </>
  );
}

AuthorShowPage.layout = DefaultLayoutWrapper;
export default AuthorShowPage;